import Ajax from "Utils/ajax";
 

export const getAllCompanyList = (data) => Ajax.post('hr/getAllCompanyList',data); 
export const getAllstaffByCompanyId = (data) => Ajax.post('account/getAllstaffByCompanyId',data);
export const getStaffSalaryHistory = (data) => Ajax.post('account/getStaffSalaryHistory',data);
export const releaseSalary = (data) => Ajax.post('account/releaseSalary',data);
